module.exports = __webpack_public_path__ + "img/menu_row2_logo.076096a9.jpg";